import React from 'react';

import { ProjectsIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <ProjectsIcon size="xsmall" label="" />;

export const useProjects = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem => {
	return useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.PROJECTS,
		analyticsName: Products.PROJECTS,
		...options,
	});
};
